export const MAX_PROFILE_BIO_LENGTH = 500;
